import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { Platform } from "@ionic/angular";

import { TranslocoService } from "@jsverse/transloco";

import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Preferences } from "@capacitor/preferences";

import { QuangAuthService } from "quang/auth";

import packageInfo from "../../package.json";
import { OAuthService } from "angular-oauth2-oidc";
import { environment } from "../environments/environment";
import { AuthControllerService } from "./store/auth-controller.service";
import { AsideComponent } from "./core/aside/aside.component";
import { QuangLoaderComponent } from "quang/loader";
import { QuangToastComponent } from "quang/overlay/toast";
import { IonApp, IonRouterOutlet } from "@ionic/angular/standalone";

@Component({
  selector: "bm-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  imports: [
    AsideComponent,
    QuangLoaderComponent,
    QuangToastComponent,
    IonApp,
    IonRouterOutlet,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AppComponent {
  readonly authController = inject(AuthControllerService);
  private readonly authService = inject(QuangAuthService);
  private readonly oauthService = inject(OAuthService);
  private readonly platform = inject(Platform);
  private readonly transloco = inject(TranslocoService);
  appVersion: string = packageInfo.version;
  inForeground = true;

  constructor() {
    environment.isApp = this.platform.is("capacitor");
    this.initializeApp();
  }

  triggerLogout(): void {
    this.authController.clearAuth();
    this.authService.logout().catch(() => {
      this.triggerLogin();
    });
  }

  triggerLogin(): void {
    this.oauthService.logOut(true);
    this.oauthService.stopAutomaticRefresh();
    window.location.reload();
  }

  initializeApp(): void {
    this.platform.ready().then(async () => {
      console.log("Init app");

      if (environment.isApp) {
        await SplashScreen.hide();
        await StatusBar.setStyle({ style: Style.Light });

        this.platform.pause.subscribe(() => {
          this.inForeground = false;
          console.log("Pause event detected");
        });

        this.platform.resume.subscribe(async () => {
          this.inForeground = true;
          console.log("Resume event detected");
          if (
            !this.oauthService.hasValidAccessToken() &&
            this.authController.isLogged()
          ) {
            this.oauthService
              .refreshToken()
              .then(() => console.log("token refreshed successfully"))
              .catch((error) => {
                console.log("token refresh did not work: " + error);
                this.triggerLogout();
              });
          }
        });
      }

      this.transloco.setDefaultLang("en");
      this.transloco.setActiveLang("en");
      await this.setAppPreferences();
    });
  }

  async setAppPreferences(): Promise<void> {
    if (environment.isApp) {
      await Preferences.set({ key: "appVersion", value: packageInfo.version });
    }
  }
}
